/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {useAppDispatch, useAppSelector} from "../../../../../../../../redux/hooks"
import {
  closeViewDataSetErrorsDialog,
  EViewDataSetErrorsDialogDataType,
  GreenLineError,
  selectGreenLineError,
  selectGreenLineName,
  selectViewDataSetErrorsDialog
} from "../../../../../../../../redux/ducks/SensingSystemArchitectureDesign"
import Flexbox from "../../../../../../../components/Containers/ArgosFlexbox"
import Button from "../../../../../../../components/Buttons/ArgosButton"
import {useState} from "react"
import {Typography} from "@mui/material"
import {ModalDialog} from "../../../../../../../components/ModalDialog/ModalDialog"
import ExpandCircleDownSharpIcon from '@mui/icons-material/ExpandCircleDownSharp'
import {renderGreenLineActionType} from "../../../../../common/helpers"
import {dateToLocaleString} from "../../../../../../../../helpers/helpers"
import {isEmpty} from "lodash";


export interface IGeneralErrorDialogErrorObject {
  exception: string
  stackTrace: string
  timestamp: string
  activity: string
}
interface IProps {
  dialogTitle: string
  error: IGeneralErrorDialogErrorObject | null
  closeDialog: () => void
}
/**
 * Dialog to view the error message details.
 */
export const GeneralErrorDialog = (props: IProps) => {
  const {dialogTitle, error, closeDialog} = props

  const onClickCloseDialog = () => {
    closeDialog()
  }

  const [showStackTrace, setShowStackTrace] = useState<boolean>(true)

  const toggleStackTrace = () => {
    setShowStackTrace(!showStackTrace)
  }

  /** Rotate icon for expand/collapse on toggle */
  const rotatedIconStyle = {
    transform: showStackTrace ? 'rotate(180deg)' : 'rotate(0deg)',
    transition: 'transform 0.3s'
  }

  const isDialogOpen = error != null
  return (
    <ModalDialog
      open={isDialogOpen}
      handleClose={onClickCloseDialog}
      title={dialogTitle}
      maxWidth={'md'}
    >
      <Flexbox vertical style={{padding: '0px', gap: '20px'}}>
        {!error && <Flexbox vertical style={{gap: '20px'}}>
          <Typography>Unable to display the error message. Please try again or contact the Argos team for assistance.</Typography>
        </Flexbox>}
        {error && <Flexbox vertical style={{ gap: '20px'}}>
          <Typography>
            {error.exception}
          </Typography>
          <Typography>
            Occurred on {dateToLocaleString(new Date(error.timestamp))} during {error.activity}
          </Typography>
          {showStackTrace && (
            <pre
              style={{
                overflowX: 'auto', backgroundColor: '#f5f5f5', padding: '10px',
                borderRadius: '5px', whiteSpace: 'pre-wrap',
                maxHeight: 600
              }}
            >
              {error.stackTrace}
            </pre>
          )}
          <Button
            onClick={toggleStackTrace}
            variant='text'
            sx={{textTransform: 'none'}}
            startIcon={<ExpandCircleDownSharpIcon sx={rotatedIconStyle} />}
            fontSize={16}
          >
            {showStackTrace ? 'Hide logs' : 'Show logs'}
          </Button>
        </Flexbox>}
      </Flexbox>
    </ModalDialog>
  )
}
